







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import dayjs from 'dayjs';
import { mask } from 'vue-the-mask';
import Assets from '@/constants/assets';
import Tooltip, { TooltipColor } from '@/shared/components/Tooltip.component.vue';

@Component({
  components: {
    Tooltip,
  },
})
export default class Field extends Vue {
  @Prop({ default: '' }) private fieldValue!: string;
  @Prop() private fieldLabel!: string;
  @Prop({ default: '' }) private fieldLinkUrl!: string;
  @Prop({ default: false }) private checkContentEllipsis!: boolean;
  @Prop({ default: false }) private squad!: boolean;

  private tooltipColor = TooltipColor;
  private labelWithEllipsis = false;
  private valueWithEllipsis = false;

  get hasLinkUrl() {
    return (this.fieldLinkUrl !== '');
  }

  get labelTooltipDisabled() {
    return !this.checkContentEllipsis || !this.labelWithEllipsis;
  }

  get valueTooltipDisabled() {
    return !this.checkContentEllipsis || !this.valueWithEllipsis;
  }

  private created() {
    if ( this.checkContentEllipsis ) {
      this.checkContentWithEllipsis();
    }
  }

  private mounted() {
      window.addEventListener( 'resize', this.checkContentWithEllipsis );
  }

  private checkContentWithEllipsis() {
    setTimeout( () => {
      if ( this.fieldLabel !== '') {
        const fieldLabelElement = ( this.$refs.refLabel as HTMLElement );
        this.labelWithEllipsis = (
          fieldLabelElement &&
          fieldLabelElement.scrollWidth > fieldLabelElement.clientWidth
        );
      }
      if ( this.fieldValue !== '') {
        const fieldValueElement = ( this.$refs.refValue as HTMLElement );
        this.valueWithEllipsis = (
          fieldValueElement &&
          fieldValueElement.scrollWidth > fieldValueElement.clientWidth
        );
      }
    }, 0 );
  }

  private hasSlot(slotName: string) {
    return !!this.$slots[slotName];
  }

  private mailToLinkUrl() {
    if ( this.hasLinkUrl ) {
      window.location.href = `mailto:${this.fieldLinkUrl}`;
    }
  }
}
